import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
export function DatenschutzPage() {
  const {
    language
  } = useLanguage();
  const isGerman = language === 'de';
  return <div className="min-h-screen bg-[#0a0e1a]" data-id="element-452">
      <Navigation data-id="element-453" />
      <main className="pt-24 pb-16" data-id="element-454">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-455">
          <h1 className="text-4xl font-bold text-white mb-12" data-id="element-456">
            {isGerman ? 'Datenschutzerklärung' : 'Privacy Policy'}
          </h1>

          <div className="prose prose-invert max-w-none space-y-8 text-gray-400" data-id="element-457">
            <section data-id="element-458">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-459">
                1. Datenschutz auf einen Blick
              </h2>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-460">
                Allgemeine Hinweise
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-461">
                Die folgenden Hinweise geben einen einfachen Überblick darüber,
                was mit Ihren personenbezogenen Daten passiert, wenn Sie diese
                Website besuchen. Personenbezogene Daten sind alle Daten, mit
                denen Sie persönlich identifiziert werden können. Ausführliche
                Informationen zum Thema Datenschutz entnehmen Sie unserer unter
                diesem Text aufgeführten Datenschutzerklärung.
              </p>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-462">
                Datenerfassung auf dieser Website
              </h3>

              <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-463">
                Wer ist verantwortlich für die Datenerfassung auf dieser
                Website?
              </h4>
              <p className="leading-relaxed mb-4" data-id="element-464">
                Die Datenverarbeitung auf dieser Website erfolgt durch den
                Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt
                „Hinweis zur Verantwortlichen Stelle" in dieser
                Datenschutzerklärung entnehmen.
              </p>

              <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-465">
                Wie erfassen wir Ihre Daten?
              </h4>
              <p className="leading-relaxed mb-4" data-id="element-466">
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
                mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie
                in ein Kontaktformular eingeben.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-467">
                Andere Daten werden automatisch oder nach Ihrer Einwilligung
                beim Besuch der Website durch unsere IT-Systeme erfasst. Das
                sind vor allem technische Daten (z. B. Internetbrowser,
                Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung
                dieser Daten erfolgt automatisch, sobald Sie diese Website
                betreten.
              </p>

              <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-468">
                Wofür nutzen wir Ihre Daten?
              </h4>
              <p className="leading-relaxed mb-4" data-id="element-469">
                Ein Teil der Daten wird erhoben, um eine fehlerfreie
                Bereitstellung der Website zu gewährleisten. Andere Daten können
                zur Analyse Ihres Nutzerverhaltens verwendet werden.
              </p>

              <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-470">
                Welche Rechte haben Sie bezüglich Ihrer Daten?
              </h4>
              <p className="leading-relaxed mb-4" data-id="element-471">
                Sie haben jederzeit das Recht, unentgeltlich Auskunft über
                Herkunft, Empfänger und Zweck Ihrer gespeicherten
                personenbezogenen Daten zu erhalten. Sie haben außerdem ein
                Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.
                Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben,
                können Sie diese Einwilligung jederzeit für die Zukunft
                widerrufen. Außerdem haben Sie das Recht, unter bestimmten
                Umständen die Einschränkung der Verarbeitung Ihrer
                personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen
                ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-472">
                Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie
                sich jederzeit an uns wenden.
              </p>

              <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-473">
                Analyse-Tools und Tools von Drittanbietern
              </h4>
              <p className="leading-relaxed mb-4" data-id="element-474">
                Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch
                ausgewertet werden. Das geschieht vor allem mit sogenannten
                Analyseprogrammen.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-475">
                Detaillierte Informationen zu diesen Analyseprogrammen finden
                Sie in der folgenden Datenschutzerklärung.
              </p>
            </section>

            <section data-id="element-476">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-477">
                2. Hosting
              </h2>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-478">
                Webflow
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-479">
                Wir hosten unsere Website bei Webflow. Anbieter ist die Webflow,
                Inc., 398 11th Street, 2nd Floor, San Francisco, CA 94103, USA
                (nachfolgend Webflow). Wenn Sie unsere Website besuchen, erfasst
                Webflow verschiedene Logfiles inklusive Ihrer IP-Adressen.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-480">
                Webflow ist ein Tool zum Erstellen und zum Hosten von Websites.
                Webflow speichert Cookies oder sonstige
                Wiedererkennungstechnologien, die für die Darstellung der Seite,
                zur Bereitstellung bestimmter Webseitenfunktionen und zur
                Gewährleistung der Sicherheit erforderlich sind (notwendige
                Cookies).
              </p>
              <p className="leading-relaxed mb-4" data-id="element-481">
                Details entnehmen Sie der Datenschutzerklärung von Webflow:{' '}
                <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-482">
                  https://webflow.com/legal/eu-privacy-policy
                </a>
                .
              </p>
              <p className="leading-relaxed mb-4" data-id="element-483">
                Die Verwendung von Webflow erfolgt auf Grundlage von Art. 6 Abs.
                1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer
                möglichst zuverlässigen Darstellung unserer Website. Sofern eine
                entsprechende Einwilligung abgefragt wurde, erfolgt die
                Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit.
                a DSGVO und § 25 Abs. 1 TTDSG, soweit die Einwilligung die
                Speicherung von Cookies oder den Zugriff auf Informationen im
                Endgerät des Nutzers (z. B. Device-Fingerprinting) im Sinne des
                TTDSG umfasst. Die Einwilligung ist jederzeit widerrufbar.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-484">
                Die Datenübertragung in die USA wird auf die
                Standardvertragsklauseln der EU-Kommission gestützt. Details
                finden Sie hier:{' '}
                <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-485">
                  https://webflow.com/legal/eu-privacy-policy
                </a>
                .
              </p>
            </section>

            <section data-id="element-486">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-487">
                3. Allgemeine Hinweise und Pflichtinformationen
              </h2>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-488">
                Datenschutz
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-489">
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
                Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
                vertraulich und entsprechend den gesetzlichen
                Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-490">
                Wenn Sie diese Website benutzen, werden verschiedene
                personenbezogene Daten erhoben. Personenbezogene Daten sind
                Daten, mit denen Sie persönlich identifiziert werden können. Die
                vorliegende Datenschutzerklärung erläutert, welche Daten wir
                erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu
                welchem Zweck das geschieht.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-491">
                Wir weisen darauf hin, dass die Datenübertragung im Internet (z.
                B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen
                kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch
                Dritte ist nicht möglich.
              </p>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-492">
                {isGerman ? 'Hinweis zur verantwortlichen Stelle' : 'Responsible Entity / Data Controller'}
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-493">
                {isGerman ? 'Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:' : 'The responsible entity for data processing on this website is:'}
              </p>
              <p className="leading-relaxed mb-4" data-id="element-494">
                CRM Kraft LLC
                <br data-id="element-495" />
                {isGerman ? 'Vertreten durch: Justus Kraft' : 'Represented by: Justus Kraft'}
                <br data-id="element-496" />
                7901 4th St. N, Ste. 300
                <br data-id="element-497" />
                St. Petersburg, FL 33702
                <br data-id="element-498" />
                United States of America
                <br data-id="element-499" />
                {isGerman ? 'Telefon' : 'Phone'}: +49 157 35999071
                <br data-id="element-500" />
                {isGerman ? 'E-Mail' : 'Email'}: justus@crm-kraft.de
              </p>
              <p className="leading-relaxed mb-4" data-id="element-501">
                {isGerman ? 'Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.' : 'The responsible entity is the natural or legal person who, alone or jointly with others, determines the purposes and means of processing personal data (for example, names or email addresses).'}
              </p>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-502">
                Speicherdauer
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-503">
                Soweit innerhalb dieser Datenschutzerklärung keine speziellere
                Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen
                Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.
                Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine
                Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten
                gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe
                für die Speicherung Ihrer personenbezogenen Daten haben (z. B.
                steuer- oder handelsrechtliche Aufbewahrungsfristen); im
                letztgenannten Fall erfolgt die Löschung nach Fortfall dieser
                Gründe.
              </p>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-504">
                SSL- bzw. TLS-Verschlüsselung
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-505">
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
                Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen
                oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine
                SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung
                erkennen Sie daran, dass die Adresszeile des Browsers von
                „http://" auf „https://" wechselt und an dem Schloss-Symbol in
                Ihrer Browserzeile.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-506">
                Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die
                Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen
                werden.
              </p>
            </section>

            <section data-id="element-507">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-508">
                4. Datenerfassung auf dieser Website
              </h2>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-509">
                Cookies
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-510">
                Unsere Internetseiten verwenden so genannte „Cookies". Cookies
                sind kleine Textdateien und richten auf Ihrem Endgerät keinen
                Schaden an. Sie werden entweder vorübergehend für die Dauer
                einer Sitzung (Session-Cookies) oder dauerhaft (permanente
                Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden
                nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies
                bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst
                löschen oder eine automatische Löschung durch Ihren Webbrowser
                erfolgt.
              </p>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-511">
                Kontaktformular
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-512">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen,
                werden Ihre Angaben aus dem Anfrageformular inklusive der von
                Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der
                Anfrage und für den Fall von Anschlussfragen bei uns
                gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung
                weiter.
              </p>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-513">
                Anfrage per E-Mail, Telefon oder Telefax
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-514">
                Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird
                Ihre Anfrage inklusive aller daraus hervorgehenden
                personenbezogenen Daten (Name, Anfrage) zum Zwecke der
                Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet.
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
            </section>

            <section data-id="element-515">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-516">
                5. Plugins und Tools
              </h2>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-517">
                YouTube
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-518">
                Diese Website bindet Videos der Website YouTube ein. Betreiber
                der Website ist die Google Ireland Limited („Google"), Gordon
                House, Barrow Street, Dublin 4, Irland.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-519">
                Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in
                der Datenschutzerklärung von YouTube unter:{' '}
                <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-520">
                  https://policies.google.com/privacy?hl=de
                </a>
                .
              </p>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-521">
                Google Web Fonts
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-522">
                Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten
                so genannte Web Fonts, die von Google bereitgestellt werden.
                Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web
                Fonts in ihren Browsercache, um Texte und Schriftarten korrekt
                anzuzeigen.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer data-id="element-523" />
    </div>;
}